import React from "react";

function Progress(props) {
  return (
    <>
      <p className="text-small">
        Kysymys {props.questionNumber} / {props.questions.length}
      </p>
    </>
  );
}

export default Progress;
